<template lang="pug">
  .loader-container(:class='[size, { "white-bg": whiteBackground }]')
    .custom-logo(v-if='schoolGroupLogo')
      img.logo(:src='schoolGroupLogo || kimpleLogo')
    simple-svg.kimple-logo(v-else :filepath='kimpleLogo' :width='loaderSize' :height='loaderSize')
</template>

<script>
import { mapState } from 'vuex'
import kimpleLogo from '../assets/ic_iso.svg'
import userRole from '../mixins/userRole'

export default {
  mixins: [userRole],
  data: () => ({
    kimpleLogo
  }),
  computed: {
    ...mapState({
      userState: state => state.userInfo,
      whiteLabelInfo: state => state.whiteLabel.info,
      hasSubdomain: state => state.whiteLabel.hasSubdomain,
      subdomainExists: state => state.whiteLabel.exists
    }),
    schoolGroupLogo() {
      if (this.hasSubdomain) return this.whiteLabelInfo.smallLogo
      else if (this.isUserLoggedIn && this.hasWhiteLabel) return this.userInfo.activeWhitelabelLicense.whitelabelLicenseConfiguration.smallLogo
      else return null
    },
    isUserLoggedIn() {
      return this.userState.userLoggedIn
    },
    loaderSize() {
      return `${this.iconSize}px`
    }
  },
  props: {
    size: { type: String, default: 'full-page' },
    iconSize: { type: Number, default: 100 },
    whiteBackground: { type: Boolean }
  }
}
</script>

<style lang="scss">
@import '../scss/variables/colors';
@import '../scss/variables/z-indexes';

.loader-container {
  z-index: $loader-layer;

  &.inner {
    height: 100%;
    width: 100%;
    z-index: $inner-loader-layer;
  }

  &.full-page {
    background-color: $black-translusent;
    height: 100vh;
    left: 0;
    position: fixed;
    top: 0;
    width: 100vw;
  }

  .kimple-logo {
    align-items: center;
    display: flex;
    justify-content: center;
    height: 100%;
  }
  // TODO: This animation needs more iterations
  .simple-svg-wrapper {
    .simple-svg {
      g > :nth-child(2) {
        animation: bounce 0.7s ease forwards infinite;
      }
    }
  }

  .custom-logo{
    align-items: center;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 100%;
    .logo{
      width: 100px;
      height: 100px;
      animation: size 0.7s ease alternate infinite;
    }
  }
}

.white-bg {
  background-color: $white;
  position: absolute;
  top: 0;
}

@keyframes bounce {
  from {
    transform: translateY(8%);
  }
  50% {
    transform: translateY(-15%);
  }
  to {
    transform: translateY(8%);
  }
}

@keyframes size {
  from {
    transform: scale(85%);
  }
  to {
    transform: scale(110%);
  }
}
</style>
